var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('p',{staticClass:"text-h5"},[_vm._v("Login")]),_c('v-btn',{attrs:{"color":"deep-orange","outlined":""},on:{"click":function($event){return _vm.login()}}},[_vm._v("sign in with genesys cloud")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }